import { isMac } from '@heidi/runtime/platform';
import { atom } from 'jotai';

import { type PermissionState } from './permissions-ports';

export const desktopDictationMicPermissionAtom = atom<PermissionState>('unknown');

export const desktopDictationAccessibilityPermissionAtom =
  atom<PermissionState>('unknown');

/**
 * Flipped once the one-shot precheck (or a settings-page equivalent) has
 * resolved. Launch queue gates the desktop onboarding modal on this so the
 * wizard can start on permissions vs key-confirm without a flash.
 */
export const desktopDictationPermissionsCheckedAtom = atom(false);

export const desktopDictationAllGrantedAtom = atom(
  (get) =>
    get(desktopDictationMicPermissionAtom) === 'granted' &&
    (!isMac || get(desktopDictationAccessibilityPermissionAtom) === 'granted')
);
